module.exports = __webpack_public_path__ + "assets/learn.35929217.svg";